export default __webpack_public_path__ + "static/media/pic.6e0ae2f0.jpg";